<template>
    <app-layout title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Notifikasi
            </h2>
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div
                                class="flex flex-wrap w-full mb-5 flex-col"
                                v-if="$page.props.count_undangan"
                            >
                                <Message severity="info" :closable="false"
                                    >Terdapat
                                    {{ $page.props.count_undangan }}
                                    undangan klarifikasi dokumen.<br />
                                    <Link
                                        :href="
                                            route('undangan.list')
                                        "
                                        class="
                                            font-bold
                                            text-red-500
                                            hover:text-red-600
                                        "
                                        >Lihat disini</Link
                                    ></Message
                                >
                            </div>
                            <div
                                class="flex flex-wrap w-full mb-5 flex-col"
                                v-if="
                                    !$page.props.count_undangan
                                "
                            >
                                <Message severity="success" :closable="false"
                                    >There's nothing to worry about.
                                </Message>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import { Link } from "@inertiajs/inertia-vue3";
import Message from "primevue/message";
import { KeluargaNotif } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        Link,
        Message,
    },
    data() {
        return {
            keluargaNotif: KeluargaNotif,
        };
    },
});
</script>
